import React, { useEffect, useState } from "react";

import Cookies from 'js-cookie';
import api, { API_URL } from "../../api";
import { PrimaryButton } from "../../components/forms/buttons";
import DashboardContainer from "../../components/dashboard/DashboardContainer";
import { Delete01Icon, Edit02Icon, PlusSignIcon } from "hugeicons-react";
import AddHospitalListPopup from "../../components/hospitals/AddHospitalListPopup ";
import EditHospitalPopup from "../../components/hospitals/EditHospitalPopup";
import DeleteHospitalPopup from "../../components/hospitals/DeleteHospitalPopup";
import { isAdminOrSuperUser } from "../../services/userPosition";
import TableLoading from "../../components/loading/TableLoading";


const HospitalsContent = () => {
  const [hospitals, setHospitals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);


  const fetchHospitals = async (page = 1) => {
    setIsLoading(true);
    try {
      const response = await api.get(`${API_URL}/hospitals/?page=${page}&page_size=${pageSize}`);
      if (response.status === 200) {
        let hospitalsData = [];
        let totalCount = 0;
        if (response.data && response.data.results && Array.isArray(response.data.results)) {
          hospitalsData = response.data.results;
          totalCount = response.data.count || hospitalsData.length;
        } else if (Array.isArray(response.data)) {
          hospitalsData = response.data;
          totalCount = hospitalsData.length;
        }
        setHospitals(hospitalsData);
        setTotalPages(Math.max(1, Math.ceil(totalCount / pageSize)));
      }
    } catch (error) {
      console.error('Error fetching hospitals:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHospitals(currentPage);
  }, [currentPage]);

  const handleAddHospital = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleAddHospitalToList = (newHospital) => {
    setHospitals((prevHospitals) => [...prevHospitals, newHospital])
  };
  const handleEditHospitalToList = (updatedHospital) => {
    setHospitals((prevHospitals) =>
      prevHospitals.map((h) => (h.id === updatedHospital.id ? updatedHospital : h))
    );
  };


  const handleDeleteHospitalFromList = (hospitalId) => {
    setHospitals((prevHospitals) => prevHospitals.filter((h) => h.id !== hospitalId));
  };

  return (
    <div className="hospital-content">
      <div className='select-button'>
        {isAdminOrSuperUser ? (
          <PrimaryButton
            onClick={handleAddHospital}
            iconClass={<PlusSignIcon />}
            buttonText={'Add Hospital'}
            type="button"
          />
        ) : null}
        {isPopupOpen && (
          <AddHospitalListPopup
            onClose={handleClosePopup}
            onAddHospital={handleAddHospitalToList}
          />
        )}
      </div>
      {hospitals.length > 0 ? (
        <div className="table-container">
          {isLoading && <TableLoading />}
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Date Created</th>
                <th>Address</th>
                <th>Phone Number</th>
                <th>CCN Number</th>
                {isAdminOrSuperUser ? <th>Action</th> : null}
              </tr>
            </thead>
            <tbody>
              {editPopupOpen && (
                <EditHospitalPopup
                  hospital={selectedHospital}
                  onClose={() => setEditPopupOpen(false)}
                  onUpdateHospital={handleEditHospitalToList}
                  fetchHospitals={() => fetchHospitals(currentPage)}
                />
              )}
              {deletePopupOpen && (
                <DeleteHospitalPopup
                  hospital={selectedHospital}
                  onClose={() => setDeletePopupOpen(false)}
                  onDeleteHospital={handleDeleteHospitalFromList}
                />
              )}
              {hospitals.map((hospital) => (
                <tr key={hospital.id}>
                  <td>{hospital.id}</td>
                  <td>{hospital.name}</td>
                  <td>{new Date(hospital.date_created).toLocaleDateString()}</td>
                  <td>{hospital.address}</td>
                  <td>{hospital.phonenumber}</td>
                  <td>{hospital.cnn}</td>
                  {isAdminOrSuperUser ? (
                    <td>
                      <div className="action-buttons">
                        <Edit02Icon
                          size={32}
                          className="edit-icon"
                          onClick={() => { setSelectedHospital(hospital); setEditPopupOpen(true); }}
                        />
                        <Delete01Icon
                          size={32}
                          className="delete-icon"
                          onClick={() => { setSelectedHospital(hospital); setDeletePopupOpen(true); }}
                        />
                      </div>
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>

        </div>

      ) : (
        <p>Hospitals</p>
      )}
      {/* Pagination Controls */}
      <div className="pagination-controls" >
        <button
          className={`previous ${currentPage === 1 ? 'disabled' : ''}`}
          onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span >
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={`next ${currentPage === totalPages ? 'disabled' : ''}`}
          onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};


const Hospitals = () => {
  return (
    <DashboardContainer content={<HospitalsContent />} pageTitle={'hospitals'} />
  )
}
export default Hospitals



